export const enum ApiDomainPaths {
  EXAMINER = '/examiner',
  ACCOUNT = '/account',
  CONFIGURATION = '/configuration',
}
